<template>
  <div class="login_box">
    <div class="centen_box">
      <div class="left">
        <div class="font_css">
          <p>管理后台</p>
        </div>
      </div>
      <div class="right">
        <div class="tabs">
          <div :class="{select: loginForm.action == 'login'}" @click="change_tabs('login')">登陆</div>
          <!-- <div :class="{select: loginForm.action == 'register'}" @click="change_tabs('register')">注册</div> -->
        </div>
        <div style="margin-top: 36px">
          <div style="margin-bottom: 11px">账号</div>
          <el-input v-model="loginForm.phone" placeholder="请输入手机号" suffix-icon="el-icon-mobile-phone"></el-input>
        </div>
        <div style="margin-top: 36px">
          <div style="margin-bottom: 11px">密码</div>
          <el-input v-model="loginForm.password" placeholder="请输入密码" type="password"></el-input>
        </div>

        <div class="acsb mt20">
          <div></div>
          <div>
            <el-radio v-model="savepwd" label="1">记住密码</el-radio>
          </div>
        </div>
        <div class="login_btn select_login_btn" @click="handleLogin">
          {{ loginForm.action == 'login' ? '登陆' : '注册' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {login, check_token, admin_info} from '@/api/api'

  export default {
    data() {
      return {
        savepwd: '',
        loginForm: {
          phone: '',
          password: '',
          action: 'login'
        }
      }
    },
    created() {
      this.admin_check_token_func()
      this.load_pwd()
    },
    methods: {
      change_tabs(str) {
        this.loginForm.action = str
      },
      admin_check_token_func() {
        check_token().then(res => {
          if (res.code == 200) {
            if (res.data == 'login') {
              this.$router.push('/msgs/center')
            }
          } else {
            localStorage.removeItem('tokena')
            localStorage.removeItem('admin_role')
            localStorage.removeItem('admin_name')
          }
        })
      },
      handleLogin() {
        login(this.loginForm).then(res => {
          if (res.code == 200) {
            try {
              this.save_pwd()
              const token = res.data.token
              const role = res.data.role
              const admin_name = res.data.admin_name
              localStorage.setItem('admin_name', admin_name)
              localStorage.setItem('tokena', token)
              localStorage.setItem('admin_role', role)
              this.$router.push('/msgs/center')
            } catch (error) {
              // 处理错误情况
              console.error('发生错误:', error)
            }
          }
        })
      },
      save_pwd() {
        if (this.savepwd == '1') {
          localStorage.setItem('user_account', this.loginForm.phone)
          localStorage.setItem('user_pwd', this.loginForm.password)
        } else {
          localStorage.removeItem('user_account')
          localStorage.removeItem('user_pwd')
        }
      },
      load_pwd() {
        if (localStorage.getItem('user_account')) {
          this.savepwd = '1'
          this.loginForm.phone = localStorage.getItem('user_account')
          this.loginForm.password = localStorage.getItem('user_pwd')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login_btn {
    margin-top: 33px;
    width: 100%;
    padding: 12px 0;
    text-align: center;
    font-size: 20px;
    background-color: #c2c7d0;
    border-radius: 4px;
    color: #ffffff;
  }

  .select_login_btn {
    background-color: #248cff;
  }

  .read {
    margin-top: 10px;
    color: #637381;
    font-size: 14px;
    display: flex;
    align-items: center;

    .fang {
      width: 18px;
      height: 18px;
      border: 1px solid #248cff;
      border-radius: 2px;
      margin-right: 6px;
    }

    .blue {
      color: #248cff;
    }
  }

  .send_code {
    cursor: pointer;
    color: #409eff;
  }

  .login_box {
    display: flex;
    justify-content: center;
    background-color: #9acaff;
    min-height: 100vh;
    width: 100%;
    align-items: center;
    background-image: url('https://s21.ax1x.com/2024/09/29/pA1DwWj.png');
    background-repeat: no-repeat;
    background-size: cover;
  }

  .centen_box {
    width: 880px;
    height: 634px;
    border-radius: 16px;
    background-color: #fff;
    display: flex;

    .font_css {
      text-align: center;
      margin-top: 88px;
      font-weight: bold;
      font-size: 28px;
      color: #ffffff;
      line-height: 23px;
    }

    .left {
      background-color: #248cff;
      border-radius: 16px 0 0 16px;
      width: 40%;
      padding-left: 30px;
      padding-top: 60px;
      background-image: url('https://s21.ax1x.com/2024/09/29/pA1DDln.png');
      background-repeat: no-repeat;
      background-size: cover;
    }

    .right {
      width: 60%;
      padding: 80px;
      color: #091e42;
      font-size: 16px;

      .tabs {
        padding: 0 80px;
        font-weight: bold;
        font-size: 24px;
        display: flex;
        justify-content: space-around;
        color: #98a1b0;

        .select {
          color: #091e42;
        }
      }
    }
  }
</style>
